import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  Box,
  Text
} from '@chakra-ui/react'
import {
  isMobile,
  isNotMobile
} from 'utils/helpers'

export const TextAnimation = ({
  item,
  blogParent,
  widen = false,
  place = '',
  finishAnimation = false
}) => {
  const textRef = useRef(null)
  const containerRef = useRef(null)
  const [animationName, setAnimationName] = useState('')

  const timeoutDuration = () => {
    if (!isNotMobile()) {
      return 850
    }

    if (place === 'profile-panel') {
      if (isMobile() && finishAnimation) {
        return 1500
      }

      return 200
    }

    return 1000
  }

  useEffect(() => {
    setAnimationName('')

    setTimeout(() => {
      const textEl = textRef.current
      const containerEl = containerRef.current
      if (!textEl || !containerEl) return

      const textWidth = textEl.scrollWidth
      const containerWidth = containerEl.offsetWidth

      if (textWidth > containerWidth) {
        const diff = (textWidth - containerWidth)
        const keyframeName = `scroll-${Math.random().toString(36).substr(2, 5)}`

        const style = document.createElement('style')
        style.innerHTML = `
          @keyframes ${keyframeName} {
            0% {
              transform: translateX(0);
              opacity: 1;
            }
            5% {
              transform: translateX(0);
              opacity: 1;
            }
            40% {
              transform: translateX(-${diff}px);
              opacity: 1;
            }
            50% {
              transform: translateX(-${diff}px);
              opacity: 0;
            }
            89% {
              transform: translateX(0);
            }
            90% {
              transform: translateX(0);
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }

          @keyframes rev-${keyframeName} {
            0% {
              transform: translateX(-${diff}px);
              opacity: 0;
            }
            40% {
              transform: translateX(0);
              opacity: 0;
            }
            50% {
              transform: translateX(0);
              opacity: 1;
            }
            90% {
              transform: translateX(-${diff}px);
              opacity: 1;
            }
            100% {
              transform: translateX(-${diff}px);
              opacity: 0;
            }
          }
        `
        document.head.appendChild(style)
        setAnimationName(keyframeName)
      } else {
        setAnimationName('')
      }
    }, timeoutDuration())
  }, [item.title, blogParent, widen])

  const handleDisplayHeader = () => {
    if (item.id !== blogParent[0]?.id || blogParent.length <= 1) {
      return item.title
    }

    const maxString = (isNotMobile() && !widen) || !isNotMobile() ? 100 : 200

    const firstLine = (blogParent[blogParent.length - 1]?.body).split('\n')[0]
    let tempDisplayTitle = firstLine.slice(0, maxString)

    if (firstLine.length > maxString) {
      tempDisplayTitle += '...'
    }

    return tempDisplayTitle
  }

  return (
    <Box
      ref={containerRef}
      overflow="hidden"
      width="100%"
      height={widen ? '30px' : '22px'}
      position="relative"
      textAlign="center"
    >
      <Text
        ref={textRef}
        animation={animationName ? `rev-${animationName} 16s linear infinite` : 'none'}
        width="max-content"
        whiteSpace="nowrap"
        position="absolute"
        display={animationName ? 'flex' : 'none'}
        padding="0 10px"
        margin="0 !important"
      >
        {handleDisplayHeader()}
      </Text>

      <Text
        ref={textRef}
        animation={animationName ? `${animationName} 16s linear infinite` : 'none'}
        width="max-content"
        whiteSpace="nowrap"
        position="absolute"
        top={animationName ? '' : '50%'}
        left={animationName ? '' : '50%'}
        transform={animationName ? '' : 'translate(-50%, -50%)'}
        padding="0 10px"
        margin="0 !important"
      >
        {handleDisplayHeader()}
      </Text>
    </Box>
  )
}
